import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { SIDEBAR } from '../../../shared/constants';
import { AccountLoopBackApiService as AccountService } from '../../../services/api/loopback/custom/account.service';

@Component({
  selector: 'drx-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class AdminSidebarComponent implements OnInit {

  @Output() onToggleSidebar: EventEmitter<any> = new EventEmitter<boolean>();

  public sidebar: any;
  public toggle: boolean;

  public constructor(private accountService: AccountService) { }

  public ngOnInit() {
    this.sidebar = SIDEBAR.user;
    if (this.accountService.isAdmin()) {
      this.sidebar = SIDEBAR.admin;
    }
    this.toggle = true;
  }

  public toggleSidebar() {
    this.toggle = !this.toggle;
    this.onToggleSidebar.emit(this.toggle);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/sidebar/sidebar.component.ts